import {
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsInt,
  IsArray,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { AddressDto } from "../common";
import { DogClassDto } from "./dog-class.dto";

export class DogShowClassesDto {
  @IsNotEmpty()
  dog_id: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => DogClassDto)
  dog_classes: DogClassDto[];

  // run time
  @IsOptional()
  @IsInt()
  start_minutes?: number;

  @IsOptional()
  time_slot?: string;

  @IsOptional()
  @IsBoolean()
  plan_to_earn_title?: boolean;

  @IsOptional()
  title?: string;

  @IsOptional()
  @IsBoolean()
  asfa_first_trial_for_hound?: boolean;

  @IsOptional()
  @IsBoolean()
  asfa_first_time_entry?: boolean;

  @IsOptional()
  @IsBoolean()
  asfa_info_changed_since_last_trial?: boolean;

  @IsOptional()
  asfa_info_changed_regarding?: string;

  @IsOptional()
  @IsBoolean()
  asfa_dismissed_last_6_trials?: boolean;

  @IsOptional()
  @IsBoolean()
  using_agent?: boolean;

  @IsOptional()
  agent_name?: string;

  @IsOptional()
  agent_number?: string;

  @IsOptional()
  @IsBoolean()
  using_non_agent?: boolean;

  @IsOptional()
  @IsBoolean()
  competing_owner_handler?: boolean;

  @IsOptional()
  agent_phone?: string;

  @IsOptional()
  agent_email?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  agent_address?: AddressDto;

  @IsOptional()
  substitute_name?: string;

  @IsOptional()
  substitute_email?: string;

  @IsOptional()
  substitute_phone?: string;

  @IsOptional()
  leg_info?: string;

  @IsOptional()
  wheelchair_type?: string;

  @IsOptional()
  needs_measurement?: boolean;
}
